module.exports = __webpack_public_path__ + "img/heart-lung.4de4e75d.png";